import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';

import CompanyLogo from '../../components/CompanyLogo';
import ContentContainer from '../../components/ContentContainer';
import Paragraph from '../../components/Paragraph';

export default class Footer extends Component {
  render() {
    return (
      <div className={css(styles.container)}>
        <ContentContainer>
          &copy; Copyright Sniffers 2017
        </ContentContainer>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    boxSizing: 'border-box',
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    width: '100vw',
    backgroundColor: Theme.primary,
    height: Theme.player.height
  }
})



// WEBPACK FOOTER //
// ./src/components/Footer/index.js